module.exports = require("injectpromise");